import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Select from 'react-select';

import coachInvoiceStatuses from 'data/coach_invoice_statuses';
import coachInvoiceTypes from 'data/coach_invoice_types';

import Datetime from 'react-datetime';

export default function Filters({
  keyword,
  setKeyword,
  filterType,
  setFilterType,
  filterStatus,
  setFilterStatus,
  filterDateStart,
  setFilterDateStart,
  filterDateEnd,
  setFilterDateEnd,
}) {
  return (
    <div className="invite_search">
      <Row>
        <Col md={3}>
          <input
            type="text"
            className="form-control"
            placeholder="Invoice, Coach or Member Name"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
          />
        </Col>

        <Col md={3}>
          <Select
            value={filterType}
            onChange={(item) => setFilterType(item)}
            placeholder="Type"
            options={coachInvoiceTypes}
            isClearable
          />
        </Col>

        <Col md={3}>
          <Select
            value={filterStatus}
            onChange={(item) => setFilterStatus(item)}
            placeholder="Status"
            options={coachInvoiceStatuses}
            isClearable
          />
        </Col>
      </Row>
      <Row className="mt20">
        <Col md={3}>
          <Datetime
            inputProps={{ placeholder: 'Date Start' }}
            value={filterDateStart != null ? filterDateStart : ''}
            timeFormat={false}
            onChange={(date) => setFilterDateStart(date)}
            renderInput={(props) => (
              <input
                {...props}
                value={
                    filterDateStart != null
                      ? typeof filterDateStart === 'string'
                        ? filterDateStart
                        : filterDateStart.format('MM/DD/YYYY')
                      : ''
                  }
              />
            )}
          />
        </Col>
        <Col md={3}>
          <Datetime
            inputProps={{ placeholder: 'Date End' }}
            value={filterDateEnd != null ? filterDateEnd : ''}
            timeFormat={false}
            onChange={(date) => setFilterDateEnd(date)}
            renderInput={(props) => (
              <input
                {...props}
                value={
                  filterDateEnd != null
                    ? typeof filterDateEnd === 'string'
                      ? filterDateEnd
                      : filterDateEnd.format('MM/DD/YYYY')
                    : ''
                  }
              />
            )}
          />
        </Col>

      </Row>
    </div>
  );
}
